import React from "react";
import CalendarDatePicker from "ui/components/comp-507";

const TimesheetAnalyticsFilters = ({ filters, setFilters }) => {
  return (
    <CalendarDatePicker
      date={{
        from: filters.startDate,
        to: filters.endDate,
      }}
      setDate={(range) =>
        setFilters({ ...filters, startDate: range?.from, endDate: range?.to })
      }
      placeholder="Pick a date range"
    />
  );
};

export default TimesheetAnalyticsFilters;
